import {
  calculateBuyerBalanceSummaryDataFromLots,
  calculatePaymentsTotalCentsFromBusiness,
  getClearingSaleLotTitle,
} from "lib/clearingSaleInvoice";

import {
  EMPTY_SUMMARY_DATA,
  BuyerPaymentSummaryData,
} from "constants/payments";
import { getPayments, getSaleLots } from "./root";
import { selectSaleLotIdsByBuyerIdLookup } from "./indexes";
import { selectDeploymentSaleBySaleLotIdLookup } from "./sales";
import { selectShouldChargeGSTByBusinessIdLookup } from "./businesses";
import { createLookupSelectors } from "./lib";

/**
 * Calculate buyer payment summary data
 */
export const [
  selectBuyerBalanceSummaryByBuyerIdLookup,
  getBuyerBalanceSummaryByBuyerId,
] = createLookupSelectors(
  [
    getSaleLots,
    selectShouldChargeGSTByBusinessIdLookup,
    selectDeploymentSaleBySaleLotIdLookup,
    selectSaleLotIdsByBuyerIdLookup,
    getPayments,
  ],
  (
    saleLots,
    shouldChargeGSTByBusinessIdLookup,
    deploymentSaleBySaleLotIdLookup,
    saleLotIdsByBuyerIdLookup,
    payments,
  ) => {
    return Object.entries(saleLotIdsByBuyerIdLookup).reduce<
      Record<string, BuyerPaymentSummaryData>
    >((acc, [buyerId, saleLotIds]) => {
      const buyerSaleLots = (saleLotIds as string[]).map(
        (id: string) => saleLots[id],
      );

      const lots = buyerSaleLots.map(saleLot => {
        const chargeSalePriceGst = saleLot.isGSTExempt
          ? false
          : shouldChargeGSTByBusinessIdLookup[saleLot.vendor_id] === true;

        return {
          saleLot,
          lotTitle: getClearingSaleLotTitle(saleLot),
          chargeSalePriceGst,
        };
      });

      const paymentsTotalCents = calculatePaymentsTotalCentsFromBusiness(
        payments,
        buyerId,
      );

      acc[buyerId] = calculateBuyerBalanceSummaryDataFromLots(
        lots,
        deploymentSaleBySaleLotIdLookup,
        paymentsTotalCents,
      );

      return acc;
    }, {});
  },
  EMPTY_SUMMARY_DATA,
);
